var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "crm-page-header"
  }, [_c('div', {
    staticClass: "crm-page-heading"
  }, [_vm.backTo ? _c('router-link', {
    staticClass: "crm-back-link",
    attrs: {
      "to": _vm.backTo
    }
  }, [_c('i', {
    staticClass: "la la-arrow-left"
  }), _c('span', [_vm._v(_vm._s(_vm.backLabel))])]) : _vm._e(), _vm._t("eyebrow"), _c('h2', [_vm._v(_vm._s(_vm.title))]), _vm.subtitle ? _c('p', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()], 2), _vm.$slots.actions ? _c('div', {
    staticClass: "crm-page-actions"
  }, [_vm._t("actions")], 2) : _vm._e(), _c('CrmTaskReminder')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };